



























































import { Component, Mixins, Prop } from "vue-property-decorator";

import InputRow from "@/components/InputRow/InputRow.vue";
import TextField from "@/components/TextField/TextField.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BaseDropdown from "@/components/BaseDropdown/BaseDropdown.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import RequestState from "@/utils/mixins/RequestState";
import { State } from "vuex-class";
import { IVuexState } from "@/models/interfaces/store";
import { ISchool } from "@/models/interfaces/schools";
import amplitude from "amplitude-js";
import { eventCodeByName, EventsNames } from "@/analytics";

@Component({
  components: {
    InputRow,
    TextField,
    BaseButton,
    BaseDropdown,

    ValidationObserver,
    ValidationProvider
  }
})
export default class ClassAddStep1 extends Mixins(RequestState) {
  @State("schools", { namespace: "schools" })
  private schools!: IVuexState<ISchool[]>;

  @Prop({ required: true, type: Array })
  private schoolsOptions!: Array<{ value: string; label: string }>;

  @Prop({ type: String })
  private initialData!: string;

  private form = {
    className: ""
  };
  private schoolId = "";

  private get showSchoolsDropdown() {
    return this.schoolsOptions && this.schoolsOptions.length > 1;
  }

  private submit() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksNextOnStep1Class)} ${
          EventsNames.UserClicksNextOnStep1Class
        }`
      );

    this.$emit("on-next", {
      schoolId: this.schoolId,
      data: this.form
    });
  }

  private async mounted() {
    if (this.schoolsOptions && this.schoolsOptions.length === 1) {
      this.schoolId = this.schoolsOptions[0].value;
    }

    if (this.initialData) {
      this.form = Object.assign(this.form, { className: this.initialData });
    }
  }
}
